// extracted by mini-css-extract-plugin
module.exports = {"vision":"styles_vision__Yt0zN","proximity":"styles_proximity__2mo10","snapped":"styles_snapped__1jBb9"};